import { FormBase } from 'core/components';

export default class FinalStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.LABELINGMODE.TRACKINGNUMBER',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/FinalStepForm.js